import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { UserService } from '../services/user.service';
import { InfraService } from './infra.service';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionService {
  private configCoreUrl: string;
 
  constructor(private infraService: InfraService, private http: HttpClient, private userService: UserService) {

    this.infraService.infraDetails$.subscribe(data => {
      this.configCoreUrl = data.WebEndPoint2 + 'userpermissions';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra')) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }

  }

  public canAccessAnalyticsReport() {
    return this.http.get<boolean>(`${this.configCoreUrl}/CanAccessAnalyticsReport`);
  }

  public canAccessUserEngReport() {
    return this.http.get<boolean>(`${this.configCoreUrl}/CanAccessUserEngagementReport`);
  }

}
